import { BIModel } from './BIModel';

// CUANDO aparece la opción de pago a plazos en el checkout

export class CheckoutInstallmentsBIModel extends BIModel {

  static eventName = 'tmp_display_installments_options';

  #productId
  #totalToPay;
  #options;

  constructor(userId, productId, totalToPay, options) {
    super(CheckoutInstallmentsBIModel.eventName, userId);
    this.#productId = productId;
    this.#totalToPay = totalToPay;
    this.#options = options;
  }

  get productId() {
    return this.#productId;
  }

  get totalToPay() {
    return this.#totalToPay;
  }

  get options() {
    return this.#options;
  }

  get modelData() {
    return {
      product_id: this.productId,
      total_to_pay: this.totalToPay,
      options: this.options
    };
  }

}